module.exports = __webpack_public_path__ + "img/bg-3.1f9ca1ba.jpg";